import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductDetails from "../pages/products/ProductDetails";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products/:productId",
    element: <ProductDetails />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
